import { render, staticRenderFns } from "./PcFeedBack.vue?vue&type=template&id=0cbd4900&scoped=true&"
import script from "./PcFeedBack.vue?vue&type=script&lang=js&"
export * from "./PcFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./PcFeedBack.vue?vue&type=style&index=0&id=0cbd4900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.2.47_css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10._wyjk5suo23ynklbyyfuevipziy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd4900",
  null
  
)

export default component.exports